module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTUxMiAxOTJhMzIgMzIgMCAwIDEgMzIgMzJ2MjU2aDI1NmEzMiAzMiAwIDAgMSAwIDY0aC0yNTZ2MjU2YTMyIDMyIDAgMCAxLTY0IDB2LTI1NkgyMjRhMzIgMzIgMCAwIDEgMC02NGgyNTZWMjI0YTMyIDMyIDAgMCAxIDMyLTMyeiIgZmlsbD0iIzAiIHAtaWQ9IjU1NCI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Add-outlined.svg
// module id = AGVN
// module chunks = 75